export default {
  header: {
    hello: "您好，欢迎来到幼儿多语境教育在线官网",
    serve: "服务热线",
    login: "登录",
    zhuce: "注册",
    en: "英",
    zh: "中"
  },
  indexNav: {
    index: "首页",
    peixun: "师资培训",
    kaoshi: "报名考试",
    about: "关于我们",
    input: "输入关键字",
    reict: "行业直聘",
    base: "项目合作"
  },
  rightNav: {
    question: "报名咨询",
    common: "公众号",
    qiye: "官方合作",
    top: "顶层"
  },
  indexVideo: {
    intro1: "直击 幼儿多语境教育模式",
    phone: "联系电话",
    address: "园区地址",
    // TODO
    intro222: "工作动态",
    li: "发展历程",
    li2: "政策公告",
    intro2:
      "帮助幼儿认知世界，开发智力、健全人格，实现全面健康快乐成长的一种全新的、系统的完整的学前教育模式"
  },
  indexClass: {
    //
    intro1: "基地合作",
    intro2: "通过系列课程学习，培养新时代复合型教师人才",
    intro3: "购买培训课程",
    intro4: "在线报名考试"
  },
  indexSchool: {
    intro1: "多语园所"
  },
  footer: {
    news: "新闻动态",
    phone: "客服电话",
    monday: "周一到周五",
    email: "邮箱",
    address: "地址：北京市怀柔区于家园南街6号",
    serve: "免责声明",
    help: "获得帮助",
    agreement: "用户协议",
    concat: "联系我们",
    href: "友情链接：华嘉国际多语",
    danwei: "倡导单位：中国民办教育协会学前教育专业委员会",
    china: "中国关心下一代工作委员会健体中心",
    create: "研发单位：中国管理科学研究院学术委员会儿童多语教育研究中心",
    //  TODO 研发机构
    code:
      "copynight@  2012-2019 北京中健时代教育科技有限责任公司   SouMate  All  Rights  Reserved  京ICP备19000971号-1  京公网安备31010702004489号",
    //  TODO 研发机构
    add1: "主办单位：中国关心下一代工作委员会健康体育发展中心",
    add2: "研发机构：中国管理科学研究院学术委员会儿童多语教育研究中心",
    add3: "执行机构：中国关心下一代工作委员会健体中心儿童多语发展计划管理委员会"
  },
  teacher: {
    sayClass: "语言培训课",
    openClass: "公开课",
    Package: "等级培训",
    Multilingual: "教育概论",
    game: "语言培训",
    toy: "生活活动",
    gameActitity: "游戏活动",
    Introduction: "课程介绍",
    note: "购买须知",
    Catalogue: "课程目录",
    recommendation: "课程推荐",
    buy: "立即购买",
    yuanprice: "原价",
    disPrice: "折扣价",
    teacherjie: "课程介绍",
    classNum: "课时",
    classType: "课程类型",
    look: "查看更多"
  },
  teacherBuy: {
    cancelOrder: "课程订单确认",
    five: "15分钟内未支付订单将会被取消",
    orderInfo: "订单信息",
    classInfo: "课程信息",
    orderNum: "订单号码",
    orderTime: "订单时间",
    classNum: "课程数量",
    payType: "支付方式",
    detail: "实付",
    payTime: "立即支付",
    codePay: "扫码支付",
    baomin: "报名信息确认",
    info: "个人信息",
    name: "姓名",
    addrress: "所在地区",
    getPe: "收货人",
    onePic: "一寸照片",
    time: "考试时间",
    type: "考试类型",
    min: "分钟"
  },
  personalCenter: {
    personNum: "确认修改信息",
    info: "基本资料",
    userName: "用户名称",
    yesInfo: "实名信息",
    sex: "性别",
    nan: "男",
    nv: "女",
    card: "身份证号",
    pleaseCard: "请输入您的身份证号",
    telePhone: "联系电话",
    address: "邮寄地址",
    changePassword: "修改密码",
    submit: "提交",
    phone: "手机号",
    code: "验证码",
    getCode: "获取验证码",
    inputPass: "输入新密码",
    commitPass: "确认新密码",
    yes: "确认修改",
    cancel: "取消",
    yeses: "确定",
    bindPhone: "绑定手机",
    logout: "退出登录",
    tools: "常用工具",
    myOrder: "我的订单",
    myKaoshi: "我的考试",
    myExam: "我的证书",
    moreClass: "更多课程"
  },
  centerOrder: {
    address: "您当前所在位置",
    orderNum: "订单编号",
    orderInfo: "订单信息",
    orderTime: "订单时间",
    orderType: "订单类型",
    orderMoney: "订单金额",
    orderStatus: "订单状态"
  },
  examCenter: {
    none: "暂未查询到您的考试资格,填写报名后才能考试",
    myExam: "我的考试",
    nowSign: "马上报名"
  },
  invoice: {
    openInvo: "开具发票",
    yesorNo: "是否开具发票",
    paper: "纸质发票",
    eleinvo: "电子发票",
    invoHeader: "发票开头",
    personel: "个人",
    compony: "公司",
    invoContent: "发票内容",
    getPeple: "收件人",
    phone: "联系电话",
    address: "详细地址",
    apply: "申请开具"
  },
  infoCenter: {
    all: "全部",
    yesRead: "全部标为已读"
  },
  classes: {
    num: "课时",
    video: "视频",
    audio: "音频",
    book: "图文",
    none: "暂无数据",
    all: "全部",
    len: "教育概论",
    teach: "语言培训",
    toy: "生活活动",
    gameActivity: "游戏活动"
  },
  addClass: {
    intro1:
      "新语境幼师等级考试时间为每周的周三和周日其中语言能力考试题型包括：选择题、听力题、语音提...",
    intro2:
      "《新语境教育师资技能等级证书》等级考试是由中国成人教育协会培训工作委员会....",
    detail: "详细>>",
    time: "考试日期"
  },

  recruit: {
    picture: "公司相册",
    concat: "联系方式",
    info: "公司基本信息",
    money: "薪资要求",
    choose: "请选择",
    serchAddress: "搜索地址",
    serchZhiwei: "搜索职位",
    serch: "搜索",
    jieshao: "公司介绍",
    job: "职位描述",
    type9: "权威机构",
    type10: "招募合作",
    type11: "合作支持",
    type12: "成功案例"
  },
  aboutUs: {
    type: "项目内容",
    teacher: "多语师资",
    center: "研究中心",
    concatUs: "联系我们",
    question: "常见问题",
    newCenter: "新闻动态",
    job: "岗位推荐",
    see: "查看更多岗位",
    intro1: "专注新语境师资培训，新语境教育师资技能等级证书",
    intro2: "《新语境教育师资技能等级证书》报名考试入口，请选择报考证书等级",

    aaaa1: "项目背景",
    aaaa2: "项目介绍",
    aaaa3: "项目价值",
    aaaa4: "项目主体", //30

    type9: "品牌合作", //3
    type10: "证书合作", //9
    type11: "教材合作", //10

    type12: "基地合作", //31
    type13: "基地申报" //32
  }
};



// WEBPACK FOOTER //
// ./src/common/lang/zh.js